import React from 'react';
import './WhyUs.css';

import { Heading } from '../../../components';
import { whyChooseUs } from '../../../constants';
import { formatTitleWithBreak } from '../../../utils';



const WhyChooseUs = () => {
  return (
    <section className="whyUs">
      <div className="box-container">
        <div className="content">

          {/* Section Heading */}
          <Heading title={whyChooseUs.heading} subTitle={whyChooseUs.sub} />

          {/* Key Features */}
          <ul className="whyUs-points">
            {whyChooseUs.points.map((point) => (
              <li key={point.id}>
                <div className="icon">{point.icon}</div> {/* Feature Icon */}
                <h5>{formatTitleWithBreak(point.title)}</h5> {/* Feature Title */}
              </li>
            ))}
          </ul>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;